import React from 'react';
import { type LatexNode } from '../types';

import ResizableParentheses from './ResizableParentheses';

export function renderLatexAST(node: LatexNode): React.ReactNode {
    switch (node.type) {
        case 'text':
            return <span className="latex-text">{node.value}</span>;
        case 'group': {
            return (
                <span className="latex-group">
                    {node.children.map((child, index) => (
                        <React.Fragment key={index}>{renderLatexAST(child)}</React.Fragment>
                    ))}
                </span>
            );
        }
        case 'fraction': {
            return (
                <span className="latex-fraction">
                    <span className="latex-fraction-wrapper">
                        <span className="latex-fraction-numerator">
                            {renderLatexAST(node.numerator)}
                        </span>
                        <span className="latex-fraction-line" />
                        <span className="latex-fraction-denominator">
                            {renderLatexAST(node.denominator)}
                        </span>
                    </span>
                </span>
            );
        }
        case 'superscript': {
            return (
                <span className="latex-sup">
                    {renderLatexAST(node.base)}
                    <sup>{renderLatexAST(node.exponent)}</sup>
                </span>
            );
        }
        case 'sqrt': {
            const { index, value } = node;
            return (
                <span className="latex-sqrt-wrapper">
                    {index && <span className="latex-sqrt-index">{renderLatexAST(index)}</span>}
                    <span className="latex-sqrt">
                        <span className="latex-sqrt-radical">√</span>
                        <span className="latex-sqrt-radicand-wrapper">
                            <span className="latex-sqrt-bar" />
                            <span className="latex-sqrt-radicand">{renderLatexAST(value)}</span>
                        </span>
                    </span>
                </span>
            );
        }
        case 'parentheses': {
            const { content } = node;
            return (
                <span className="latex-parentheses">
                    <span className="latex-parentheses-left">(</span>
                    {renderLatexAST(content)}
                    <span className="latex-parentheses-right">)</span>
                </span>
            );
        }
        case 'resizable-parentheses': {
            const { content } = node;
            return <ResizableParentheses content={content} />;
        }

        default:
            return null;
    }
}
